import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { shippingAddresses } from "api/shippingAddresses";
import { useOrder } from "context/OrderContext";
import React, { useEffect, useState } from "react";

function CustomerInfo({ handleNext, activeStep }) {
  const {
    orderReference,
    setOrderReference,
    shippingAddress,
    setShippingAddress,
    deliveryMethod,
    setDeliveryMethod,
    comments,
    setComments,
  } = useOrder();

  const [errors, setErrors] = useState({});
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getAddresses = async () => {
      setLoading(true);
      try {
        const { data, status } = await shippingAddresses();
        if (status === "success" && Array.isArray(data)) setAddresses(data);
        else setAddresses(data.data);
      } catch (error) {
        console.error("Failed to fetch shipping addresses:", error);
        setAddresses([]);
      } finally {
        setLoading(false);
      }
    };

    getAddresses();
  }, []);

  const handleSubmit = () => {
    const newErrors = {};
    if (!shippingAddress) {
      newErrors.shippingAddress = "Leveringsadresse er påkrævet";
    }
    if (!deliveryMethod) {
      newErrors.deliveryMethod = "Leveringsmetode er påkrævet";
    }
    if (!orderReference) {
      newErrors.orderReference = "Ordrereference er påkrævet";
    }
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setShippingAddress(shippingAddress);
      setDeliveryMethod(deliveryMethod);
      handleNext();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <FormControl fullWidth error={!!errors.selectedAddress}>
        <InputLabel>Leveringsadresse</InputLabel>
        <Select
          value={shippingAddress}
          label="Leveringsadresse"
          onChange={(e) => setShippingAddress(e.target.value)}
        >
          {addresses.length > 0 ? (
            addresses.map((address) => (
              <MenuItem key={address.Code} value={address}>
                {address.Code}
                {address.Address ? `- ${address.Address}` : ""}
                {address.Address_2 ? `- ${address.Address_2} ` : ""}
                {address.Post_Code ? `, ${address.Post_Code} ` : ""}
                {address.City ? `, ${address.City} ` : ""}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>No addresses available</MenuItem>
          )}
        </Select>
        {errors.selectedAddress && (
          <Typography variant="caption" color="error">
            {errors.selectedAddress}
          </Typography>
        )}
      </FormControl>

      <FormControl fullWidth error={!!errors.deliveryMethod}>
        <InputLabel>Leveringsmetode</InputLabel>
        <Select
          value={deliveryMethod}
          label="Leveringsmetode"
          onChange={(e) => setDeliveryMethod(e.target.value)}
        >
          {[
            "Postnord",
            "Danske Fragtmænd",
            "Brink (Natlevering)",
            "Afhentning",
            "Uden for døren",
          ].map((method, index) => (
            <MenuItem key={index} value={method}>
              {method}
            </MenuItem>
          ))}
        </Select>
        {errors.deliveryMethod && (
          <Typography variant="caption" color="error">
            {errors.deliveryMethod}
          </Typography>
        )}
      </FormControl>

      <TextField
        fullWidth
        label="Ordrereference"
        value={orderReference}
        onChange={(e) => setOrderReference(e.target.value)}
        error={!!errors.orderReference}
        helperText={errors.orderReference}
      />

      <TextField
        fullWidth
        label="Kommentarer"
        multiline
        rows={3}
        value={comments}
        onChange={(e) => setComments(e.target.value)}
      />

      <Button
        fullWidth
        variant="contained"
        onClick={handleSubmit}
        sx={{
          width: "100%",
          height: "40px",
          backgroundColor: "#424242",
          borderRadius: "5px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexShrink: 0,

          marginTop: 2,
          "&:hover": {
            backgroundColor: "#686868",
          },
        }}
      >
        Næste
      </Button>
    </Box>
  );
}

export default CustomerInfo;
